// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal--modal--3cdks","preventClickOutside":"Modal--prevent-click-outside--3357p","fixed":"Modal--fixed--3-Nk-","full":"Modal--full--3O5Ih"};